document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-model.zoom_wrapper');
  const closeBtn = document.getElementById('ModalClose');

  document.querySelectorAll('.main_image_inner').forEach((el, index) => {
    el.addEventListener('click', () => {
      modal.classList.add('active');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => {
        initModalSwiper();
        initZoomInsideModal();
        // modalSwiper.slideTo(index);
      }, 300);
    });
  });

  closeBtn?.addEventListener('click', () => {
    modal.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    resetAllZoom();
  });
});

let modalSwiper;
let thumbSwiper;

function initModalSwiper() {
  if (modalSwiper && thumbSwiper) return;

 thumbSwiper = new Swiper('.custom_thumbnail_slider', {
  slidesPerView: 7,
  spaceBetween: 10,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.thumb-next',
    prevEl: '.thumb-prev',
  },
  breakpoints: {
    0: {
      slidesPerView: 5
    },
    768: {
      slidesPerView: 7
    }
  }
});

  modalSwiper = new Swiper('.main_image_popup_slider', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.main-next',
      prevEl: '.main-prev',
    },
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    thumbs: {
      swiper: thumbSwiper,
    },
  });

  // Reset zoom on every slide's images whenever the active slide changes,
  // so a zoomed-in image doesn't carry its zoom state to the next view.
  modalSwiper.on('slideChange', resetAllZoom);
}

function initZoomInsideModal() {
  const zoomEls = document.querySelectorAll('.main_image_popup_slider .main_image_inner img');

  zoomEls.forEach(img => {
    // Already initialized on a previous modal open — skip.
    if (img._panzoom) return;

    const panzoom = Panzoom(img, {
      maxScale: 4,
      minScale: 1,
      contain: 'outside',
      cursor: 'zoom-in',
    });
    img._panzoom = panzoom;

    // Mouse wheel / trackpad zoom (desktop). Pinch-to-zoom and drag-to-pan
    // on touch devices are handled natively by Panzoom itself.
    img.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);

    // While the image is zoomed in, hand touch control over to Panzoom
    // so panning the image doesn't also swipe the slider to the next photo.
    img.addEventListener('panzoomchange', (event) => {
      const isZoomedIn = event.detail.scale > 1;
      if (modalSwiper) {
        modalSwiper.allowTouchMove = !isZoomedIn;
      }
      img.style.cursor = isZoomedIn ? 'zoom-out' : 'zoom-in';
    });

    // Double-click (desktop) / double-tap (touch) toggles zoom in and out.
    bindDoubleTapZoom(img, panzoom);
  });
}

function bindDoubleTapZoom(img, panzoom) {
  const toggleZoom = (event) => {
    if (panzoom.getScale() > 1) {
      panzoom.reset();
      img.style.cursor = 'zoom-in';
      if (modalSwiper) modalSwiper.allowTouchMove = true;
    } else {
      panzoom.zoomToPoint(2.5, event);
    }
  };

  img.addEventListener('dblclick', (event) => {
    event.preventDefault();
    toggleZoom(event);
  });

  // Manual double-tap detection as a touch fallback, since 'dblclick' isn't
  // consistently fired from double-tap gestures on touch devices.
  // Track whether the current touch gesture ever involved more than one
  // finger (a pinch) — a pinch's two fingers lifting off in quick
  // succession fires two 'touchend' events close together, which would
  // otherwise be mistaken for a double-tap and incorrectly reset the zoom
  // the instant the customer lets go.
  let isPinchGesture = false;
  let lastTap = 0;

  img.addEventListener('touchstart', (event) => {
    if (event.touches.length > 1) {
      isPinchGesture = true;
    }
  });

  img.addEventListener('touchend', (event) => {
    // Only treat this as "gesture fully ended" once every finger is up.
    const gestureEnded = event.touches.length === 0;

    if (isPinchGesture) {
      if (gestureEnded) isPinchGesture = false;
      return; // never treat a pinch's finger-lift as a double-tap
    }

    const now = Date.now();
    if (now - lastTap < 300) {
      event.preventDefault();
      toggleZoom(event.changedTouches[0]);
    }
    lastTap = now;
  });
}

function resetAllZoom() {
  document.querySelectorAll('.main_image_popup_slider .main_image_inner img').forEach(img => {
    img._panzoom?.reset();
    // 'reset' doesn't fire the 'panzoomchange' event, so sync the cursor here.
    img.style.cursor = 'zoom-in';
  });
  if (modalSwiper) {
    modalSwiper.allowTouchMove = true;
  }
}
